var LogOn = function() {
	var comp = $('[data-component="log-on"]');
	var tl = new TimelineMax();

	function init() {
		//addListeners();
		//formValidate();
	}

	function addListeners() {
		// Avança para o step 2
		comp.find('.next-1').on('click', function(e) {
			e.preventDefault();

			comp.closest('[data-page]').find('.block').addClass('increase');
			comp.find('.txtUserName').text(comp.find('#txtUserName').val());

			var step1 = comp.find('[data-step="1"]');
			var step2 = comp.find('[data-step="2"]');

			//if (comp.find('#divFormLogin').validate().element('#txtUserName')) {
				animateStep(step1, step2);
			//}
		});

		// Volta para o step 1
		comp.find('.back').on('click', function(e) {
			e.preventDefault();

			comp.closest('[data-page]').find('.block').removeClass('increase');

			var step1 = comp.find('[data-step="1"]');
			var step2 = comp.find('[data-step="2"]');

			animateStep(step2, step1);
		});

		// Limpa o input do step atual
		comp.find('.clear').on('click', function(e) {
			e.preventDefault();
			$(this).closest('.step').find('input').val('');
		});

		// Prossegue para a próxima etapa
		// comp.find('.login').on('click', function(e) {
		// 	e.preventDefault();
		// 	if (comp.find('#formLogin').valid()) {
		// 		comp.find('#formLogin').submit();
		// 	}
		// });
	}

	// Define os campos a serem validados
	function formValidate() {
		comp.find('#Form1').validate({
			rules: {
				"txtUserName": "required",
				"txtPassword": "required"
			}
		});
	}

	// Animação de troca de step
	function animateStep(first, second) {
		TweenMax.to(first, .8, {left: '-100%', right: 'auto'});
		TweenMax.fromTo(second, .8,
			{left: '100%', right: 'auto'},
			{left: '0', right: '0', visibility: 'visible'}
		);
	}

	return init();
}

$(document).ready(function() {
	if ($('[data-component="log-on"]').length > 0) {
		new LogOn();
	}
});
